import React, { ReactNode } from "react";
import { Col, Row } from "react-bootstrap";
import { GroupLayout } from "./FormGroupLayout";

export interface FormFullScreenLayoutProps {
  label?: ReactNode;
  leftRender?: () => ReactNode;
  rightRender?: () => ReactNode;
  helpText?: ReactNode;
  isRequired?: boolean;
  className?: string;
}

const FormFullScreenLayout: React.FC<FormFullScreenLayoutProps> = ({
  label,
  leftRender,
  rightRender,
  helpText,
  isRequired,
  className,
}) => {
  return (
    <GroupLayout
      xs={12}
      sm={12}
      md={3}
      lg={2}
      xl={2}
      label={label}
      isRequired={isRequired}
      leftRender={leftRender}
      className={className}
      rightRender={() => (
        <Row>
          <Col
            className={`${!helpText ? "align-self-center" : ""}`}
            xs={12}
            lg={6}
          >
            {rightRender && rightRender()}
          </Col>
          {helpText && (
            <Col xs={12} lg={6} className="d-flex">
              {helpText}
            </Col>
          )}
        </Row>
      )}
    />
  );
};

export default FormFullScreenLayout;
